<template>
  <div class="index">
    <div class="mui-bar index_head" style="overflow:hidden">
      <span class="mui-left"><i class="iconfont icon-dizhi-copy"></i>{{address[1]}}</span>
      <h1 class="mui-title" style="right: 60px;left: 60px;">云学员一点通</h1>
      <ul class="head_ico">
        <li class="iconfont icon-saomiao" @click="showWithWaiting"></li>
        <li class="iconfont icon-xiaoxi-" @click="$app.goTo('/newslist')"></li>
      </ul>
    </div>
    <div class="mui-content index_content ptop9">
      <!--banner-->
      <div class="index_banner">
        <div class="mui-slider">
          <div class="mui-slider-group mui-slider-loop">
            <!-- 额外增加的一个节点(循环轮播：第一个节点是最后一张轮播) -->
            <div class="mui-slider-item mui-slider-item-duplicate">
              <a  @click="focusUrl(attachments[attachments.length==0?0:attachments.length-1].appurl)">
                <img :src="attachments[attachments.length==0?0:attachments.length-1].image">
              </a>
            </div>

            <div class="mui-slider-item" v-for="item in attachments">
              <a @click="focusUrl(item.appurl)">
                <img :src="item.image">
              </a>
            </div>
            <!-- 额外增加的一个节点(循环轮播：最后一个节点是第一张轮播) -->
            <div class="mui-slider-item mui-slider-item-duplicate">
              <a @click="focusUrl(attachments[0].appurl)">
                <img :src="attachments[0].image">
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--导航 理论培训点-->
      <ul class="mui-row index_nav" v-if="$store.state.userInfo.isreal==1&&$store.state.userInfo.user_level_driving==6">
        <li class="mui-col-xs-6 mui-col-sm-6">
          <a @click="$app.goTo('/stulist')">
            <div class="nav_tb bg7">
              <i class="iconfont icon-xueyuanguanli"></i>
            </div>
            <p>学员管理</p>
          </a>
        </li>
        <li class="mui-col-xs-6 mui-col-sm-6">
          <a @click="$app.goTo('/poster')">
            <div class="nav_tb bg9">
              <i class="iconfont icon-haibao"></i>
            </div>
            <p>招生海报</p>
          </a>
        </li>
      </ul>
      <!--导航 驾校-->
      <ul class="mui-row index_nav" v-if="$store.state.userInfo.isreal==1&&$store.state.userInfo.user_level_driving==5">
        <li class="mui-col-xs-4 mui-col-sm-4">
          <a @click="$app.goTo('/infojx')">
            <div class="nav_tb bg11">
              <i class="iconfont icon-guanli"></i>
            </div>
            <p>驾校管理</p>
          </a>
        </li>
        <li class="mui-col-xs-4 mui-col-sm-4">
          <a @click="$app.goTo('/stulist')">
            <div class="nav_tb bg7">
              <i class="iconfont icon-xueyuanguanli"></i>
            </div>
            <p>学员管理</p>
          </a>
        </li>
        <li class="mui-col-xs-4 mui-col-sm-4">
          <a @click="$app.goTo('/paiche')">
            <div class="nav_tb bg8">
              <i class="iconfont icon-vehicle"></i>
            </div>
            <p>训练车预约</p>
          </a>
        </li>
        <li class="mui-col-xs-4 mui-col-sm-4">
          <a @click="$app.goTo('/poster')">
            <div class="nav_tb bg9">
              <i class="iconfont icon-haibao"></i>
            </div>
            <p>招生海报</p>
          </a>
        </li>
		<li class="mui-col-xs-4 mui-col-sm-4">
			<a @click="goTo('/mypictureadd')">
				<div class="nav_tb bg5">
				    <i class="iconfont icon-zhaopian"></i>
				</div>
				<p>照片处理</p>
			</a>
		</li>
		<li class="mui-col-xs-4 mui-col-sm-4">
			<a @click="goTo('/mypicture')">
				<div class="nav_tb bg6">
				    <i class="iconfont icon-zhaopian"></i>
				</div>
				<p>我的照片</p>
			</a>
		</li>
      </ul>
      <!--导航 教练-->
      <ul class="mui-row index_nav" v-if="$store.state.userInfo.isreal==1&&$store.state.userInfo.user_level_driving==3">
        <li class="mui-col-xs-4 mui-col-sm-4">
          <a @click="$app.goTo('/stulist')">
            <div class="nav_tb bg7">
              <i class="iconfont icon-xueyuanguanli"></i>
            </div>
            <p>学员管理</p>
          </a>
        </li>
<!--         <li class="mui-col-xs-4 mui-col-sm-4">-->
<!--          <a @click="$app.goTo('/yuyue')">-->
<!--            <div class="nav_tb bg8">-->
<!--              <i class="iconfont icon-yuyue"></i>-->
<!--            </div>-->
<!--            <p>训练车预约</p>-->
<!--          </a>-->
<!--        </li>-->
		<li class="mui-col-xs-4 mui-col-sm-4">
		  <a @click="$app.goTo('/discount')">
		    <div class="nav_tb bg5">
		      <i class="iconfont icon-qiaquan"></i>
		    </div>
		    <p>优惠卡券</p>
		  </a>
		</li>
        <li class="mui-col-xs-4 mui-col-sm-4">
          <a @click="$app.goTo('/poster')">
            <div class="nav_tb bg9">
              <i class="iconfont icon-haibao"></i>
            </div>
            <p>招生海报</p>
          </a>
        </li>
        <li class="mui-col-xs-4 mui-col-sm-4">
          <a @click="$app.goTo('/addprize')">
            <div class="nav_tb bg10">
              <i class="iconfont icon-jiangzhuang"></i>
            </div>
            <p>发奖状</p>
          </a>
        </li>
		<li class="mui-col-xs-4 mui-col-sm-4">
			<a @click="$app.goTo('/infogl')">
				<div class="nav_tb bg2">
					<i class="iconfont icon-guanli"></i>
				</div>
				<p>信息管理</p>
			</a>
		</li>
		<li class="mui-col-xs-4 mui-col-sm-4">
			<a @click="goTo('/mypictureadd')">
				<div class="nav_tb bg8">
				    <i class="iconfont icon-zhaopian"></i>
				</div>
				<p>照片处理</p>
			</a>
		</li>
      </ul>
      <!--导航 学员-->
      <ul class="mui-row index_nav" v-if="$store.state.userInfo.isreal!=1">
        <li class="mui-col-xs-4 mui-col-sm-4">
          <a @click="goTo('/signup')">
            <div class="nav_tb bg1">
              <i class="iconfont icon-baoming"></i>
            </div>
            <p>报名</p>
          </a>
        </li>
        <li class="mui-col-xs-4 mui-col-sm-4" v-if="$store.state.userInfo.user_level_id>0||$store.state.userInfo.isreal==1">
          <a @click="$app.goTo('/h5Index')">
            <div class="nav_tb bg2">
              <i class="iconfont icon-tiku"></i>
            </div>
            <p>题库</p>
          </a>
        </li>
        <li class="mui-col-xs-4 mui-col-sm-4" v-if="$store.state.userInfo.user_level_id==0||$store.state.userInfo.isreal!=1">
          <a @click="$app.goTo('/vip')">
            <div class="nav_tb bg2">
              <i class="iconfont icon-tiku"></i>
            </div>
            <p>题库</p>
          </a>
        </li>
        <li class="mui-col-xs-4 mui-col-sm-4">
          <a @click="goTo('/prize')">
            <div class="nav_tb bg3">
              <i class="iconfont icon-jiangzhuang"></i>
            </div>
            <p>我的奖状</p>
          </a>
        </li>
        <li class="mui-col-xs-4 mui-col-sm-4" v-if="iosAudit!='ios'">
          <a @click="goTo('/stuprogress')">
            <div class="nav_tb bg4">
              <i class="iconfont icon-xueche"></i>
            </div>
            <p>学习进度</p>
          </a>
        </li>
        <li class="mui-col-xs-4 mui-col-sm-4" v-if="iosAudit!='ios'">
          <a @click="goTo('/mypictureadd')">
            <div class="nav_tb bg5">
              <i class="iconfont icon-tupian1"></i>
            </div>
            <p>图片处理</p>
          </a>
        </li>
        <li class="mui-col-xs-4 mui-col-sm-4" v-if="iosAudit!='ios'">
          <a @click="goTo('/introduce')">
            <div class="nav_tb bg6">
              <i class="iconfont icon-diban-"></i>
            </div>
            <p>考场介绍</p>
          </a>
        </li>
      </ul>

		<div class="gai_bg">
			<!-- 观看 -->
			<div class="gk_box" @click="$app.goTo('/video')">
				<div class="box_left clearfix">
					<h3>{{$store.state.userInfo.region1}}考场路线实拍视频</h3>
					<button type="button">提前看考场</button>
					<span><img src="../assets/mui/img/gimg01.png" alt=""></span>
				</div>
				<div class="box_right">
					<span v-if="kcNumber!=0">覆盖{{$store.state.userInfo.region1}}{{kcNumber}}个考场</span>
					<div class="img_box">
						<img src="../assets/mui/img/gimg03.png" alt="">
					</div>
					<div class="gk_line">
						<span><img src="../assets/mui/img/gimg05.png" alt=""></span>
					</div>
				</div>
			</div>
			<!-- 分享 -->
			<div class="fx_box" v-if="$store.state.userInfo.isextension==1">
				<ul>
					<li>
						<a @click="$app.goTo('/tuijianlilun')">
						  <div class="tuij_img">
						    <img src="../assets/mui/css/img/tuij1.png" />
						  </div>
						  <div class="tuij_wb">
						    <span>分享5单最高收益</span>
						    <em>455元</em>
						  </div>
						</a>
					</li>
					<li>
					  <a @click="$app.goTo('/tuijianvideo')">
					    <div class="tuij_img">
					      <img src="../assets/mui/css/img/tuij2.png" />
					    </div>
					    <div class="tuij_wb">
					      <span>考试精选视频</span>
					      <em>100%收益</em>
					    </div>
					  </a>
					</li>
				</ul>
				<div class="fx_bt">
					<img src="../assets/mui/img/gimg06.png" alt="">
				</div>
			</div>
			<!-- 学习 -->
			<div class="xuex_box" @click="$app.goTo('/h5Index')">
				<h2>科目一科目四精选600题</h2>
				<ul>
					<li><span>不过包赔80</span></li>
					<li><span>真人视频讲解</span></li>
					<li><span>最快三小时通关</span></li>
					<li><span>本地题库</span></li>
				</ul>
				<div class="xuex_btn">
					<button type="button">开始学习</button>
				</div>
				<div class="xuxbt">
					<img src="../assets/mui/img/gimg07.png" alt="">
				</div>
			</div>
		</div>

      <!--选项卡-->
      <div class="nav_box1">
        <ul class="nav_box">
          <li v-bind:class="{active:navbox==5}"><a @click="activeBox(5)">图文信息</a></li>
          <li v-bind:class="{active:navbox==2}" v-if="$store.state.userInfo.isreal==1&&$store.state.userInfo.user_level_driving==3"><a
            @click="activeBox(2)">附近理论培训点</a></li>
          <li v-bind:class="{active:navbox==6}" v-if="$store.state.userInfo.isreal==1&&$store.state.userInfo.user_level_driving==3"><a
            @click="activeBox(6)">教练圈</a></li>
          <li v-bind:class="{active:navbox==1}" v-if="$store.state.userInfo.user_level_driving!=4"><a @click="activeBox(1)">附近考场</a></li>
          <li v-bind:class="{active:navbox==3}" ><a @click="activeBox(3)">驾校</a></li>
          <li v-bind:class="{active:navbox==4}" v-if="$store.state.userInfo.user_level_driving!=3&&$store.state.userInfo.user_level_driving!=5"><a
              @click="activeBox(4)">教练</a></li>
          <li v-for="(item,index) in shopTypeList" v-bind:class="{active:navbox==(7+index)}"><a @click="activeBox((7+index),item.id)">{{item.name}}</a></li>
        </ul>
      </div>
      <div class="sx_box">
        <i class="iconfont icon-paixu"></i>
        &nbsp;排序筛选
        <i class="iconfont icon-icon mui-pull-right"></i>
      </div>
      <!--附近考场-->
      <div class="xxk_tab" v-if="navbox==1">
        <ul class="mui-table-view">
          <li class="mui-table-view-cell mui-media" v-for="item in dataList" @click="$app.goTo('/detailjx',{id:item.id,t:'kc'})">
            <a>
              <img class="mui-media-object mui-pull-left" v-bind:src="item.imge|url" />
              <div class="mui-media-body">
                <h4><span class="mui-ellipsis">{{item.subject}}</span><em class="mui-pull-right">{{item.distance}}</em></h4>
                <div class="phone"><i class="iconfont icon-dianhua1"></i>{{item.phone}}</div>
                <div class="address mui-ellipsis"><i class="iconfont icon-weizhi"></i>{{item.address}}</div>
                <div class="ms">
                  <span v-for="tag in item.tags">{{tag}}</span>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <!--附近理论培训点-->
      <div class="xxk_tab" v-if="navbox==2">
        <ul class="mui-table-view">
          <li class="mui-table-view-cell mui-media" v-for="item in dataList" @click="$app.goTo('/detailjx',{id:item.id,t:'px'})">
            <a>
              <img class="mui-media-object mui-pull-left" v-bind:src="item.imge|url" />
              <div class="mui-media-body">
                <h4><span class="mui-ellipsis">{{item.subject}}</span><em class="mui-pull-right">{{item.distance}}</em></h4>
                <div class="phone"><i class="iconfont icon-dianhua1"></i>{{item.phone}}</div>
                <div class="address mui-ellipsis"><i class="iconfont icon-weizhi"></i>{{item.address}}</div>
                <div class="ms">
                  <span v-for="tag in item.tags">{{tag}}</span>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <!--驾校-->
      <div class="xxk_tab" v-if="navbox==3">
        <ul class="mui-table-view">
          <li class="mui-table-view-cell mui-media" v-for="item in dataList" @click="$app.goTo('/detailjx',{id:item.id})">
            <a>
              <img class="mui-media-object mui-pull-left" v-bind:src="item.imge|url" />
              <div class="mui-media-body">
                <h4><span class="mui-ellipsis">{{item.subject}}</span><em class="mui-pull-right">{{item.distance}}</em></h4>
                <div class="phone"><i class="iconfont icon-dianhua1"></i>{{item.phone}}</div>
                <div class="address mui-ellipsis"><i class="iconfont icon-weizhi"></i>{{item.address}}</div>
                <div class="ms">
                  <span v-for="tag in item.tags">{{tag}}</span>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <!--教练-->
      <div class="xxk_tab jl_content" v-if="navbox==4">
        <ul class="mui-table-view">
          <li class="mui-table-view-cell mui-media" v-for="item in dataList" @click="$app.goTo('/detailjl',{id:item.id})">
            <a>
              <img class="mui-media-object mui-pull-left" v-bind:src="item.avatar" />
              <div class="mui-media-body">
                <h4><span class="mui-ellipsis">{{item.nickname}}</span><em class="mui-pull-right">{{item.distance}}</em></h4>
                <div class="phone"><i class="iconfont icon-dianhua1"></i>{{item.mobile}}</div>
                <div class="address mui-ellipsis"><i class="iconfont icon-weizhi"></i>{{item.region0}}{{item.region1}}{{item.region2}}</div>
                <p>通过率：{{item.passing_rate}}</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <!--图文信息-->
      <div class="tuw_box" v-if="navbox==5">
        <ul class="">
          <li class="" v-for="item in dataList" @click="$app.goTo('/detailinfo',{id:item.id,type:'tuwen'})">
            <a>
              <img class="mui-pull-right" v-bind:src="item.image|url">
              <div class="tuw_body mui-pull-left">
                <h4>{{item.title}}</h4>
                <p class="mui-ellipsis">{{item.description}}</p>
                <div>
                  {{item.create_at}}
                  <span><i class="iconfont icon-pinglun"></i> {{item.comment_number}}</span>
                  <span><i class="iconfont icon-guankan"></i> {{item.view}}</span>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <!--简报(供求信息 教练圈)-->
      <div class="tuw_box" v-if="navbox==6">
        <ul class="">
          <li class="" v-for="item in dataList" @click="$app.goTo('/detailinfo',{id:item.id,type:'jianbao'})">
            <a>
              <img class="mui-pull-right" v-bind:src="item.image|url">
              <div class="tuw_body mui-pull-left">
                <h4>{{item.title}}</h4>
                <p class="mui-ellipsis">{{item.description}}</p>
                <div>
                  {{item.create_at}}
                  <span><i class="iconfont icon-pinglun"></i> {{item.comment_number}}</span>
                  <span><i class="iconfont icon-guankan"></i> {{item.view}}</span>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <!--洗车店面-->
      <div class="dm_box" v-if="navbox>6">
        <ul class="">
          <li class="" v-for="item in dataList" @click="$app.goTo('/shopdetail',{id:item.id})">
            <a>
              <h4>{{item.title}}</h4>
              <span><i class="iconfont icon-weizhi"></i>{{item.address}}</span>
              <div class="dm_img">
                <img v-for="focus in item.focusimage" v-bind:src="focus" class="mui-pull-left" />
              </div>
            </a>
          </li>

        </ul>
      </div>
      <div class="pl_more">
        <a>{{tips}} </a>
      </div>
    </div>
		<div class="ts_tel" v-if="$store.state.userInfo.school_tel&&$store.state.userInfo.user_level_driving == 4" @click="gotel($store.state.userInfo.school_tel)">
			<span>教学</span>
			<span>投诉</span>
		</div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      attachments: [{
        image: ''
      }],
      addressColumns: [],
      address_change: ['云南省', '昆明市'],
      address: ['云南省', '昆明市'],
      cityPicker: {},
      navbox: 5,
      dataList: [],
      lng: '',
      lat: '',
      page: 1,
      pagesize: 5,
      contentWebview: null,
      nWaiting: null,
      bitmap: null,
      topoffset: 0,
      _back: {},
      shopTypeList: [],
      shopTypeId: {},
      REQUIRE: true,
      tips: '努力加载中...',
      iosAudit: {},
      isLocaltion: false,
      ct: 'C1/C2/C3',
      kcNumber: 0,
      contentView: null,
      linkView: null
    }
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    },
    url (val) {
      return val + '.thumb240x156.jpg'
    }
  },
  components: {},
  methods: {
    goTo (path) {
      this.$router.push(path)
    },
    intload () {
      var that = this
      if (that.$store.state.userInfo.user_level_driving == 4) {
        that.navbox = 3
      }
      that.loadData(that.navbox, true)
      // 添加滚动事件，检测滚动到页面底部
      window.addEventListener('scroll', that.scrollBottom)
    },
    locationPos () {
      var that = this
      this.$app.getCurrentPosition().then((res) => {
        console.log('定位成功')
        console.log(res)
        var r = JSON.parse(res)
        that.formatPoint(r.location.latitude, r.location.longitude)
        that.intload()
        // 通过坐标获取区域城市
        var locationInfo = new BMap.Geocoder()
        var point = new BMap.Point(r.location.longitude, r.location.latitude)
        locationInfo.getLocation(point, function (result) {
          that.address = [result.addressComponents.province, result.addressComponents.city]
          that.$app.locationAddressDetail = [result.addressComponents.province, result.addressComponents.city]
          that.setPoint(result.addressComponents.province, result.addressComponents.city, result.addressComponents
            .district)
          console.log(result.addressComponents)
        }, {
          poiRadius: 100,
          numPois: 10
        })
      }).catch((res) => {
        this.$wx.confirm({
          message: '请允许我们获取您的地理位置',
          title: '提醒',
          btnValue: ['重新定位', '取消'],
          callback: function (e) {
            if (e.index == 0) {
              that.locationPos()
            } else {
              that.$app.locationAddressed = true
              that.$wx.showToast('定位失败')
              that.$app.locationAddressDetail = ['云南省', '昆明市']
              // that.$refs.addressPicker.setValues(that.$app.locationAddressDetail)
              console.log(that.$app.locationAddressDetail)
              that.intload()
            }
          }
        })
      })
    },
    /**
       * 加载商家类型
       */
    laodShopType () {
      this.$app.pr('/api/appshopmerchuser/get_type').then((res) => {
        this.shopTypeList = res.data.datalist
      })
    },
    addressPicker () {
      var that = this
      this.cityPicker.show(function (items) {
        console.log(items)
        that.address = [items[0].text, items[1].text]
      })
    },
    activeBox (index, id) {
      if (id) {
        this.shopTypeId = id
      }
      this.navbox = index
      this.loadData(index, true)
    },
    formatPoint (latitude, longitude) { // 百度地图坐标转化腾讯地图坐标
      var that = this
      if (longitude != null && longitude != '' && latitude != null && latitude != '') {
        // 百度地图坐标转换腾讯地图坐标
        var x_pi = 3.14159265358979324
        var x = parseFloat(longitude) - 0.0065
        var y = parseFloat(latitude) - 0.006
        var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
        var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
        that.lng = (z * Math.cos(theta)).toFixed(7)
        that.lat = (z * Math.sin(theta)).toFixed(7)
      }
    },
    loadData (index, isFirst) {
      var that = this
      if (isFirst == true) { // 判断是否首次加载
        that.dataList = []
        that.REQUIRE = true
        that.page = 1
      }

      var url = ''
      var params = {}

      switch (index) {
        case 1: // 附近考场
          url = '/api/examination/getlist_by_point'
          params = {
            latitude: that.lat,
            longitude: that.lng,
            page: that.page,
            pagesize: that.pagesize
          }
          break
        case 2: // 附近理论培训点
          url = '/api/training/getlist_by_point'
          params = {
            latitude: that.lat,
            longitude: that.lng,
            page: that.page,
            pagesize: that.pagesize
          }
          break
        case 3: // 驾校
          url = '/api/school/getlist_by_point'
          params = {
            latitude: that.lat,
            longitude: that.lng,
            page: that.page,
            pagesize: that.pagesize
          }
          break
        case 4: // 教练
          url = '/api/appuser/getlist_by_jl'
          params = {
            latitude: that.lat,
            longitude: that.lng,
            page: that.page,
            pagesize: that.pagesize
          }
          break
        case 5: // 图文信息
          url = '/api/Appnewsimagetext/lists'
          params = {
            page: that.page,
            pagesize: that.pagesize
          }
          break
        case 6: // 简报(供求信息 教练圈)
          url = '/api/Appbriefing/lists'
          params = {
            page: that.page,
            pagesize: that.pagesize
          }
          break
      }

      if (index > 6) {
        url = '/api/Appshopmerchuser/getlist_by_type'
        params = {
          shoptype: that.shopTypeId,
          page: that.page,
          pagesize: that.pagesize
        }
      }

      this.tips = '努力加载中...'
      this.$app.pr(url, params).then((res) => {
        if (res.success) {
          if (res.data.datalist.length > 0) {
            for (var i = 0; i < res.data.datalist.length; i++) {
              that.dataList.push(res.data.datalist[i])
            }
            this.tips = ''
          } else {
            if (isFirst) {
              that.tips = '暂无数据'
            } else {
              that.tips = '没有更多了'
            }
            this.REQUIRE = false
          }
        }
      }).catch((res) => {
        // that.$wx.showToast('加载失败')
      })
      this.page++
    },
    /**
       * 更新当前登录用户坐标
       */
    setPoint (province, city, area) {
      var that = this
      this.$app.pr('/api/appuser/update_location', {
        lat: that.lat,
        lng: that.lng,
        region0: province,
        region1: city,
        region2: area
      }).then((res) => {
        console.log('坐标更新情况:')
        console.log(res)
      }).catch((res) => {})
    },
    plusReady () {
      var that = this
      if (plus.navigator.isImmersedStatusbar()) { // 兼容沉浸式状态栏模式
        that.topoffset = Math.round(plus.navigator.getStatusbarHeight())
      }
      var bdata =
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABYCAYAAAADWlKCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAKwwAACsMBNCkkqwAAABZ0RVh0Q3JlYXRpb24gVGltZQAwOS8xMi8xM5w+I3MAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzVxteM2AAACcklEQVR4nO3a0XESURiG4TeO99iBWoGZ+RvADtKBpAPtwBLsANJBrEAs4MyYDmIHSQXkgk0mMLK7ILt8/+F778ici394OGfDsher1Qqn05tTD+A2M4hYBhHLIGIZRCyDiGUQsQwilkHEMohYBhHLIGIZRCyDiGUQsQwilkHEMohYBhHLIGIZRCyDiGUQsQwilkHEMohYb089wNCVUq6Ay+blfUQsTjhOZxc1P9tbSlkAX7b+/C0ifpxgnF5Ve2TtwAD4OvIoe1UlSAsGwPsRR9m76kA6MAD+jjTKQVUF0gMD4HaEUQ6umot6T4ybiJgNP83hVbFDasGACnZIT4yfEXE1wjj/Xeod0hPjDpgNPsyRSguyB8Y0Ih6Gn+g4pQSpFQMSgtSMAclAaseARCDngAFJQM4FAxKAnBMGiH8xLKVMgV89ln6MiPthpxkn6R0SEUvgusfSZSnlsnuZftI75LlSygyYdyx7ZH1s/Rl+ouFKAQIvx9ctMGlZlh4lDQhAcywtqRhF+hqyXfMmT1m/6buasL6mzMaY6dilAoENlLuWZRNgnhEl1ZH1ulLKO9bH16eOpdfqz2K9Lt0Oea75EjilfadAsp2SFgQ2UH53LJ2XUr4PPtARSntkbVfL7+rVgEBvlM/NHQDJUh9Z2zWf/puOZbPhJzm8qkDgBaXt/teHcSY5rOpAAJp/c/vclJSrShDYifKI+NPvVV3U/1VzU3LavFyo/25SPUi2qj2ysmYQsQwilkHEMohYBhHLIGIZRCyDiGUQsQwilkHEMohYBhHLIGIZRCyDiGUQsQwilkHEMohYBhHLIGIZRCyDiGUQsZ4Ak9fPFwUy/HsAAAAASUVORK5CYII='
      that.bitmap = new plus.nativeObj.Bitmap('back')
      that.bitmap.loadBase64Data(bdata, function () {
        that.bitmap.isLoadSuccess = true
        that.nWaiting && that.nWaiting.drawBitmap(that.bitmap, null, {
          top: that.topoffset + 'px',
          left: '0px',
          width: '44px',
          height: '44px'
        }, 'backicon')
        console.log('Back bitmap load success')
      }, function (e) {
        console.log('Back bitmap load failed: ' + JSON.stringify(e))
      })

      // 创建nWaiting
      this.creatWaiting()
    },
    /**
       * 创建原生View控件
       */
    creatWaiting () {
      var that = this
      console.log('creatWaiting: ' + that.topoffset)
      // 判断view是否已存在，避免重复创建，尤其调试刷新网页时很容易触发重复创建
      that.nWaiting = plus.nativeObj.View.getViewById('nWaiting')
      if (that.nWaiting) {
        return
      }
      that.nWaiting = new plus.nativeObj.View('nWaiting', {
        top: '0px',
        left: '0px',
        height: '100%',
        width: '100%'
      })
      that.nWaiting.interceptTouchEvent(true)

      // 初始化绘制nwaiting界面
      that.nWaiting.drawRect('#2aaffb', {
        top: '0px',
        left: '0px',
        height: (that.topoffset + 44) + 'px',
        width: '100%'
      }) // 绘制title背景色
      that.bitmap && that.bitmap.isLoadSuccess && that.nWaiting.drawBitmap(that.bitmap, null, {
        top: that.topoffset + 'px',
        left: '0px',
        width: '44px',
        height: '44px'
      }, 'backicon')
      that.nWaiting.drawText('1', {
        top: that.topoffset + 'px',
        left: '0px',
        width: '100%',
        height: '44px'
      }, {
        size: '17px',
        color: '#fff'
      })
      that.nWaiting.drawRect('#EEEEEE', {
        top: (that.topoffset + 44) + 'px',
        left: '0px',
        width: '100%'
      }) // 绘制等待内容区背景色
      that.nWaiting.drawText('加 载 中 ...', {
        top: (that.topoffset + 44) + 'px',
        left: '0px',
        width: '100%',
        height: '50%'
      }, {
        size: '12px',
        color: 'rgb(100,100,100)'
      })
    },
    // 使用原生View控件作为动画模板显示窗口
    showWithWaiting () {
      var that = this
      var bShow = false
      var bUpdate = false
      console.log(that.$store.state.webdomain + 'barcode')
      that.contentWebview = plus.webview.create(that.$store.state.webdomain + 'barcode', 'contendWebview', {
        titleNView: {
          autoBackButton: true,
          backgroundColor: '#2aaffb',
          titletText: '扫一扫',
          titleColor: '#fff'
        }
      })
      that.contentWebview.addEventListener('close', function () {
        that.contentWebview = null
      })
      that.contentWebview.addEventListener('titleUpdate', function () {
        bUpdate = true
        bShow && that.nWaiting.hide()
      }, false)
      that.contentWebview.addEventListener('loaded', function () { // 兼容titleUpdate事件不触发的情况
        bUpdate || (bUpdate = true, bShow && that.nWaiting.hide())
      }, false)
      that.contentWebview.show('pop-in', null, function () {
        bShow = true
        bUpdate && that.nWaiting.hide()
      }, {
        capture: that.nWaiting
      })
    },
    safeback () {
      // var that = this;
      // that.contentWebview ? that.contentWebview.close('pop-out') : (that.bitmap && that.bitmap.clear(), that.nWaiting &&
      //   that.nWaiting.clear());
      //
      // if(that.contentView)
      // {
      //   var url=that.contentView.getURL();
      //   if(url.indexOf('c=entry&actid=')!=-1){
      //     that.contentView.close('pop-out');
      //   }else{
      //     that.contentView.back();
      //   }
      // }
    },
    scrollBottom () {
      const top = document.documentElement.scrollTop || document.body.scrollTop
      // 滚动到页面底部时
      if (((window.screen.height + top) >= (document.body.clientHeight)) && this.REQUIRE) {
        this.loadData(this.navbox, false)
      }
    },
    getLocation () {
      var that = this
      plus.geolocation.getCurrentPosition(that.showPosition, that.showError) // h5+获取定位的经纬度,获取成功则调用showPosition,失败则调用showError.
    },
    showPosition (position) {
      var that = this
      that.isLocaltion = true
      // 同plus拉取坐标类型为gcj02坐标  兼容腾讯和高德地图
      var lng = position.coords.longitude // 经度
      var lat = position.coords.latitude // 纬度
      that.lng = position.coords.longitude
      that.lat = position.coords.latitude
      // gcj02坐标 转 百度坐标
      var x_pi = 3.14159265358979324
      var x = parseFloat(lng)
      var y = parseFloat(lat)
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi)
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi)
      lng = (z * Math.cos(theta) + 0.0065).toFixed(5)
      lat = (z * Math.sin(theta) + 0.006).toFixed(5)
      // 加载数据
      that.intload()
      // 通过坐标获取区域城市
      var locationInfo = new BMap.Geocoder()
      var point = new BMap.Point(lng, lat)
      locationInfo.getLocation(point, function (result) {
        that.address = [result.addressComponents.province, result.addressComponents.city]
        that.$app.locationAddressDetail = [result.addressComponents.province, result.addressComponents.city]
        that.setPoint(result.addressComponents.province, result.addressComponents.city, result.addressComponents
          .district)
        console.log(result.addressComponents)
      }, {
        poiRadius: 100,
        numPois: 10
      })
    },
    showError (error) {
      var that = this
      switch (error.code) {
        case error.PERMISSION_DENIED:
          that.$wx.showToast('定位失败,用户拒绝请求地理定位')
          break
        case error.POSITION_UNAVAILABLE:
          that.$wx.showToast('定位失败,位置信息是不可用')
          break
        case error.TIMEOUT:
          that.$wx.showToast('定位失败,请求获取用户位置超时')
          break
        case error.UNKNOWN_ERROR:
          that.$wx.showToast('定位失败,定位系统失效')
          break
      }
      that.intload()
    },
    /*
      通过所在城市获取视频考场数
       */
    getKcNumber () {
      var that = this
      this.$app.pr('/api/video/getkc.html', {
        'city': that.$store.state.userInfo.region1
      }).then((res) => {
        that.kcNumber = res.data.count
      })
    },
    /*
      焦点图跳转
       */
    focusUrl (url) {
      var that = this
      if (url.indexOf('OilIndex') != -1 && url.indexOf('app://') === 0) {
        if (!this.$store.state.config.jtype || 1) {
          if (plus.webview.getWebviewById('subview')) {
            plus.webview.getWebviewById('subview').show()
          } else {
            this.$wx.showLoading('正在加载')
            var webv = plus.webview.create(this.$store.state.webdomain + 'OilIndex', 'subview', {
              backButtonAutoControl: 'none',
              statusbar: {background: '#fc345a'},
              plusrequire: 'ahead'
            })
            webv.setStyle({'popGesture': 'none'})
            webv.setStyle({ scrollIndicator: 'none'})
            webv.addEventListener('loaded', function () {
              that.$wx.hideLoading()
              webv.show()
            })
          }
        } else {
          that.$app.goTo(url.replace('app://', ''))
        }
      } else {
        // 防止页面后退
        history.pushState(null, null, document.URL)
        window.addEventListener('popstate', function () {
          history.pushState(null, null, document.URL)
        })

        if (url.indexOf('http') != -1) {
          var bShow = false
          var bUpdate = false
          url = url + '&terminal=app&appuid=' + that.$store.state.userInfo.openid
          that.contentView = plus.webview.create(url, 'contentView', {
            backButtonAutoControl: 'none',
            titleNView: {
              autoBackButton: true,
              backgroundColor: '#2aaffb',
              titletText: '学员一点通',
              titleColor: '#fff'
            }
          })

          // that.$app.goTo('/my');
          that.contentView.addEventListener('close', function () {
            that.contentView = null
          })
          that.contentView.addEventListener('titleUpdate', function () {
            bUpdate = true
            bUpdate = true
          }, false)
          that.contentView.addEventListener('loaded', function () { // 兼容titleUpdate事件不触发的情况
            bUpdate || (bUpdate = true)
          }, false)
          that.contentView.show('pop-in', null, function () {
            bShow = true
          }, {
            capture: null
          })
        } if (url.indexOf('link://') === 0) {
          var linkId = url.replace('link://', '')
          this.$app.pr('/api/Userscore/Linksscore.html', {
            'id': linkId
          }).then((res) => {
            if (res.success) {
              var linkurl = res.data.url

              var bbShow = false
              var bbUpdate = false
              that.linkView = plus.webview.create(linkurl, 'linkContentView', {
                backButtonAutoControl: 'none',
                titleNView: {
                  autoBackButton: true,
                  backgroundColor: '#2aaffb',
                  titletText: '学员一点通',
                  titleColor: '#fff'
                }
              })

              // that.$app.goTo('/my');
              that.linkView.addEventListener('close', function () {
                that.linkView = null
              })
              that.linkView.addEventListener('titleUpdate', function () {
                bbUpdate = true
                bbUpdate = true
              }, false)
              that.linkView.addEventListener('loaded', function () { // 兼容titleUpdate事件不触发的情况
                bbUpdate || (bbUpdate = true)
              }, false)
              that.linkView.show('pop-in', null, function () {
                bbShow = true
              }, {
                capture: null
              })
            } else {
              this.$wx.showToast(res.message)
            }
          })
        } else {
          that.$app.goTo(url)
        }
      }
    },
    /**
       * 拨打电话
       */
    gotel (number) {
      if (window.plus) {
        plus.device.dial(number)
      } else {
        this.$wx.showToast('只有在APP端才能拨打电话')
      }
    }
  },
  mounted () {
    // alert($(".mui-title").html())
    var that = this
    // 级联示例
    this.cityPicker = new mui.PopPicker({
      layer: 2
    })
    this.cityPicker.setData(this.citydata)
    // 设置默认选项
    this.cityPicker.pickers[0].setSelectedIndex(24)
    this.cityPicker.pickers[1].setSelectedIndex(0)
    // 商家推荐分类
    this.laodShopType()

    if (window.plus) {
      that.plusReady()
    } else {
      document.addEventListener('plusready', that.plusReady, false)
    }

    if (this.$store.state.config.jtype) // 判断是否ios
    {
      var t = setTimeout(function () {
        if (that.isLocaltion == false) {
          // 加载数据
          that.intload()
        }
      }, 3000)
    } else {
      var t = setTimeout(function () {
        if (that.isLocaltion == false) {
          // 加载数据
          that.getLocation()
        }
      }, 10000)
    }
    that.getKcNumber()
    /**
       * 调取当前用户定位，如在app环境采用原生定位
       */
    if (window.plus) {
      that.getLocation()
    } else {
      document.addEventListener('plusready', that.getLocation, false)
    }
  },
  created () {
    this.$app.pr('/api/adv/indexall.html', {}).then((res) => {
      this.attachments = res.data.advList.adv_1.attachments
      setTimeout(function () {
        // 获得slider插件对象
        var gallery = mui('.mui-slider')
        gallery.slider({
          interval: 5000 // 自动轮播周期，若为0则不自动播放，默认为0；
        })
      }, 3000)
    })
  },
  /**
     * 检测用户身份信息是否发生了改变
     */
  activated () {
    var that = this

    // 审核配置 begin
    this.iosAudit = 'app'
    // this.iosAudit=localStorage.getItem("apptype");
    // 审核配置 end

    this.$app.pr('/api/appuser/get_user.html').then((res) => {
      if (res.success) {
        if ((res.data.school_tel != that.$store.state.userInfo.school_tel) || (res.data.isreal != that.$store.state.userInfo.isreal) || (res.data.user_level_driving != that.$store
          .state.userInfo.user_level_driving) || (res.data.user_level_id != that.$store.state.userInfo.user_level_id)|| (res.data.isextension != that.$store.state.userInfo.isextension) || (res.data.openid != that.$store.state.userInfo.openid)) {
          that.$app.refreshUser(res.data) // 刷新本地用户信息
          /**
             * 调取当前用户定位，如在app环境采用原生定位
             */
          if (window.plus) {
            this.getLocation()
          } else {
            // 定位并加载内容
            this.locationPos()
          }
        }
      }
    })

    // 判断是否绑定手机
    if (!this.$store.state.userInfo.mobile) {
		console.log("首页转向到绑定页");
      this.$router.push('/binding') // 绑定手机页
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* touch-action: none; */
	.ts_tel{
		position: fixed;
		right: .2rem;
		bottom: 2.1rem;
		width: .9rem;
		height: .9rem;
		background-color: #00C0FF;
		border-radius: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.ts_tel span{
		font-size: .26rem;
		color: #fff;
		display: block;
		line-height: .3rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue